import axios from 'axios';
import maxbo from './maxbo';
import log from './log';
const shippingapi = {

    async getAllRows() {
        let response = await maxbo.getAllRows();
        return response.data;
    },

    async getShipping(customer) {
        let shipping = {};
        
        if (!customer.test) {
            let response = await maxbo.getShipping(customer.number);
            console.log('shipping data', response.data);
            shipping = response.data;
            //console.log(JSON.stringify(response));
        }else {
            log.w('using shipping TEST data');
            let response = await axios.get('testdata/shipping1.json');
            //console.log('shipping data', response.data.data);
            shipping = response.data.data;
            await new Promise(r => setTimeout(r, 100));
        }

        return shipping;
    },

    async getShippingAndRows(customerNumber) {
        let shipping = {};
        let response = await maxbo.getShippingAndRows(customerNumber);
        shipping = response.data;
        return shipping;
    },

    async overwriteShipping(customerNumber, shipping) {
        const rows = await maxbo.overwriteShipping(customerNumber, shipping);
        return rows;
    },

    setOriginalPrices(shipping, values) {
        shipping.days7.price = values["1"].price;
        shipping.days3.price = values["2"].price;
        shipping.low.price = values["3"].price;
        shipping.med.price = values["4"].price;
        shipping.high.price = values["5"].price;
        shipping.precision.price = values["6"].price;
        shipping.express.price = values["7"].price;
        shipping.crane.price = values["8"].price;
    },

    setMaxDiscounts(shipping, values) {
        shipping.days7.maxDiscount = values["1"].value;
        shipping.days3.maxDiscount = values["2"].value;
        shipping.low.maxDiscount = values["3"].value;
        shipping.med.maxDiscount = values["4"].value;
        shipping.high.maxDiscount = values["5"].value;
        shipping.precision.maxDiscount = values["6"].value;
        shipping.express.maxDiscount = values["7"].value;
        shipping.crane.maxDiscount = values["8"].value;
    },

    setDropdownDiscounts(shipping, values) {
        console.log('values', values);
        shipping.days7.ddDiscount = values["1"].maxvalue;
        shipping.days3.ddDiscount = values["2"].maxvalue;
        shipping.low.ddDiscount = values["3"].maxvalue;
        shipping.med.ddDiscount = values["4"].maxvalue;
        shipping.high.ddDiscount = values["5"].maxvalue;
        shipping.precision.ddDiscount = values["6"].maxvalue;
        shipping.express.ddDiscount = values["7"].maxvalue;
        shipping.crane.ddDiscount = values["8"].maxvalue;
    },

    getThresholdValues(values) {
        const list = [];
        for (const key in values) {
            list.push({
                key: key,
                value: values[key].value,
                display: values[key].display,
            });
        }
        console.log('LIST', list);
        return list;
    },

    getPDFValues(shipping, values) {
        const pdfs = {
            days7: {},
            days3: {},
            low: {},
            med: {},
            high: {},
            precision: {
                hours4: {},
                hours1: {}
            },
            express: {},
            crane: {
                normal: {},
                big1: {},
                big2: {},
                extra: {}
            }
        };

        this.getPDFdt(pdfs.days7, shipping.days7);
        this.getPDFp(pdfs.days7, shipping.days7, shipping.days7.price);

        this.getPDFdt(pdfs.days3, shipping.days3);
        this.getPDFp(pdfs.days3, shipping.days3, shipping.days3.price);

        this.getPDFdt(pdfs.low, shipping.low);
        this.getPDFp(pdfs.low, shipping.low, shipping.low.price);

        this.getPDFdt(pdfs.med, shipping.med);
        this.getPDFp(pdfs.med, shipping.med, shipping.med.price);

        this.getPDFdt(pdfs.high, shipping.high);
        this.getPDFp(pdfs.high, shipping.high, shipping.high.price);

        this.getPDFdt(pdfs.precision, shipping.precision);
        this.getPDFp(pdfs.precision.hours1, shipping.precision, shipping.precision.price);

        this.getPDFdt(pdfs.precision, shipping.precision);
        this.getPDFp(pdfs.precision.hours4, shipping.precision, values["12"].price);

        this.getPDFdt(pdfs.express, shipping.express);
        this.getPDFp(pdfs.express, shipping.express, shipping.express.price);

        this.getPDFdt(pdfs.crane, shipping.crane);
        this.getPDFp(pdfs.crane.big1, shipping.crane, shipping.crane.price);

        this.getPDFdt(pdfs.crane, shipping.crane);
        this.getPDFp(pdfs.crane.normal, shipping.crane, values["9"].price);

        this.getPDFdt(pdfs.crane, shipping.crane);
        this.getPDFp(pdfs.crane.big2, shipping.crane, values["10"].price);

        this.getPDFdt(pdfs.crane, shipping.crane);
        this.getPDFp(pdfs.crane.extra, shipping.crane, values["11"].price);

        pdfs.med.threshold = pdfs.low.threshold + ' og ' + pdfs.high.threshold;
        return pdfs;
    },

    getPDFdt(pdf, value) {
        pdf.threshold = this.formatMoney(value.threshold);
        pdf.discount = value.discount;
    },

    getPDFp(pdf, value, price) {
        pdf.price = price;
        pdf.originalPrice = this.formatMoney(price);
        pdf.discountPrice = this.formatMoney(Math.round(Number(price) - ((Number(price) * Number(value.discount)) / 100)));
    },

    formatMoney(amount) {
        let value = parseFloat(amount).toFixed(0)
        var str = "";
        if (value.toString().length > 6) {
            let index1 = value.toString().length - 6;
            let index2 = value.toString().length - 3;
            str = value.toString().substring(0, index1) + "." + value.toString().substring(index1, index2) + "." + value.toString().substring(index2);
        }else if (value.toString().length > 3) {
            let index = value.toString().length - 3;
            str = value.toString().substring(0, index) + "." + value.toString().substring(index);
        }else {
            str = value.toString();
        }
        return str;
    },

};
export default shippingapi;